'use client';

import React from 'react';
import { FiX } from 'react-icons/fi';

import type { TimeChartItem } from 'src/types/chart';
import type { Resolution } from '@blockscout/stats-types';

import ChartWidgetContent from './ChartWidgetContent';

import styles from './FullscreenChartModal.module.css';

type Props = {
  isOpen: boolean;
  title: string;
  description?: string;
  items: Array<TimeChartItem>;
  onClose: () => void;
  units?: string;
  resolution?: Resolution;
  zoomRange?: [ Date, Date ];
  handleZoom: (range: [ Date, Date ]) => void;
  handleZoomReset: () => void;
};

const FullscreenChartModal = ({
  isOpen,
  title,
  description,
  items,
  units,
  onClose,
  resolution,
  zoomRange,
  handleZoom,
  handleZoomReset,
}: Props) => {
  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [ isOpen ]);

  if (!isOpen) return null;

  return (
    <div className={ styles.overlay } onClick={ onClose }>
      <div className={ styles.content } onClick={ (e) => e.stopPropagation() }>
        <div className={ styles.header }>
          <div>
            <h2 className={ styles.title }>{ title }</h2>
            { description && <p className={ styles.description }>{ description }</p> }
          </div>
          <div className={ styles.headerActions }>
            { zoomRange && (
              <button className={ styles.resetButton } onClick={ handleZoomReset }>
                Reset zoom
              </button>
            ) }
            <button className={ styles.closeButton } onClick={ onClose }>
              <FiX size={ 20 }/>
            </button>
          </div>
        </div>
        <div className={ styles.body }>
          <ChartWidgetContent
            isEnlarged
            items={ items }
            units={ units }
            handleZoom={ handleZoom }
            zoomRange={ zoomRange }
            title={ title }
            resolution={ resolution }
          />
        </div>
      </div>
    </div>
  );
};

export default FullscreenChartModal;
